import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import axios from "axios";
import { Trash } from "lucide-react";
import { toast } from "react-toastify";
import { Selection } from "./ChampVisuelParameter";

export function SelectTimeline({
  selection,
  setSelection,
  selections,
  setSelections,
}: {
    setSelection: (selection: Selection) => void;
    selection: Selection
    selections: Selection[];
    setSelections: React.Dispatch<React.SetStateAction<Selection[]>>;
}
) {
  if (!Array.isArray(selections)) {
    console.error("selections is not an array:", selections);
    return null;
  }

  const deleteTimeline = async (
    selectionId: string,
    patientId: string,
  ): Promise<void> => {
    try {
      await axios.delete(
        `/practitioner/visualField/${selectionId}/${patientId}`
      );
      // Optionnel: afficher un toast de succès à l'utilisateur
      toast.success("Zone de travail supprimée.");
      // Mettre à jour les sélections après la suppression
      setSelections((prevSelections: Selection[]) => {
     
        const filteredSelections = prevSelections.filter((option) => {
          return option.id !== selectionId;
        });
        
        return filteredSelections;
      });

      // Réinitialiser la sélection si elle correspond à celle supprimée
      if (selection?.id === selectionId) {
        setSelection({
          id: "",
          timeline: "",
          patientId: "",
          selection: "",
          isDefault: false,
        }); 
      }
    } catch (error) {
      console.error("Error deleting timeline:", error);
        // Optionnel: afficher un toast d'erreur à l'utilisateur
      toast.error("Erreur lors de la suppression.");
    } 
  };

  return (
    <div className="flex items-center space-x-2">
      <Select
        onValueChange={(value) => {
          const filteredSelection = selections.find(
            (option) => option.timeline === value
          );
          if (filteredSelection) {
            setSelection(filteredSelection);
          }
        }}
      >
        <SelectTrigger
          onClick={(e) => {
            e.stopPropagation(); // Empêche la propagation du clic au composant sous-jacent
          }}
        >
          <SelectValue placeholder="Sélectionner" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="none">Aucune sélection</SelectItem>
          {selections.map((option) => (
            <SelectItem key={option.id} value={option.timeline}>
              {option.timeline}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {selection && selection?.timeline !== "Automatique" && (
        <Dialog>
          <DialogTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              aria-label="Supprimer la timeline sélectionnée"
            >
              <Trash className="h-4 w-4 text-red-600 hover:text-red-800" />
            </Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Confirmation de la suppression</DialogTitle>
            </DialogHeader>
            <p className="my-4">
              Êtes-vous sûr de vouloir supprimer la zone de travail "
              {selection.timeline}" ?
            </p>
            <DialogFooter className="flex justify-end space-x-2">
              <DialogClose asChild>
                <Button variant="outline">
                  Annuler
                </Button>
              </DialogClose>
              <DialogClose asChild>
                <Button
                  variant="destructive"
                  onClick={() => {
                    deleteTimeline(selection.id, selection.patientId);
                  }}
                >
                  Supprimer
                </Button>
              </DialogClose>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
